import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { onChangeParkingRadiusFilter } from '../../../ac/onChangeMapFilters';
import { PARKING_RADIUS_FILTER } from '../../../constants/filterStyles';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const ParkingRadiusComponent = ({
    mapFilters,
    onChangeParkingRadiusFilter,
}) => {
    const { style, styleKey, reduxPath } = PARKING_RADIUS_FILTER;
    // ✅ Получаем items из стиля через resolver
    const items = getStyleFilterItems(style, styleKey);
    return (
        <div>
            <div style={{ padding: '10px' }}>
                <small>{t`Включить радиусы парковок:`}</small>
            </div>
            <div className={styles.checkboxIconGrid}>
                {
                    items.map(({ value, color, label }) => (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={color}
                                width='2vw'
                                height='2vw'
                                opacity='0.8'
                            />
                            <label htmlFor={label.id}>{i18n._(label)}</label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type='checkbox'
                                        name='poi'
                                        id={value}
                                        checked={mapFilters[reduxPath].includes(value)}
                                        value={value}
                                        onChange={onChangeParkingRadiusFilter}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    ))
                }
            </div>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeParkingRadiusFilter })(ParkingRadiusComponent);
export const ParkingRadiusFilter = withDisplayedLayersCheck(ConnectedComponent, t`Парковки с радиусом_fin`);
